import { berachain, berachainBepolia, kaia, kairos } from '@lair-finance/wagmi/chains'
import { isDevelopment } from '@/shared/constants/env.ts'
import { getIconPath } from '@/shared/lib/utils/asset.ts'
import { injectiveTestnet } from '@/domains/chain/chains/injectiveTestnet.ts'
import { parseEther } from 'ethers'
import { somnia } from '@/domains/chain/chains/somnia.ts'
import { IS_INJECTIVE_TEST_SERVER } from '@/shared/config'
import { Chain } from 'viem'
import { somniaTestnet } from '@/domains/chain/chains/somniaTestnet.ts'

export const Chains = {
  KAIA: kaia,
  KAIA_TESTNET: kairos,
  BERA: berachain,
  BERA_TESTNET: berachainBepolia,
  INJECTIVE_TESTNET: injectiveTestnet,
  SOMNIA: somnia,
  SOMNIA_TESTNET: somniaTestnet,
} as const

export const ChainById = {
  [Chains.KAIA.id]: Chains.KAIA,
  [Chains.KAIA_TESTNET.id]: Chains.KAIA_TESTNET,
  [Chains.BERA.id]: Chains.BERA,
  [Chains.BERA_TESTNET.id]: Chains.BERA_TESTNET,
  [Chains.INJECTIVE_TESTNET.id]: Chains.INJECTIVE_TESTNET,
  [Chains.SOMNIA.id]: Chains.SOMNIA,
  [Chains.SOMNIA_TESTNET.id]: Chains.SOMNIA_TESTNET,
} as const

export enum ChainId {
  KAIA = Chains.KAIA.id,
  KAIA_TESTNET = Chains.KAIA_TESTNET.id,
  BERA = Chains.BERA.id,
  BERA_TESTNET = Chains.BERA_TESTNET.id,
  INJECTIVE_TESTNET = Chains.INJECTIVE_TESTNET.id,
  SOMNIA = Chains.SOMNIA.id,
  SOMNIA_TESTNET = Chains.SOMNIA_TESTNET.id,
}

export const ActiveChain = {
  KAIA: isDevelopment ? Chains.KAIA_TESTNET : Chains.KAIA,
  BERA: isDevelopment ? Chains.BERA_TESTNET : Chains.BERA,
  INJECTIVE: Chains.INJECTIVE_TESTNET,
  SOMNIA: isDevelopment ? Chains.SOMNIA_TESTNET : Chains.SOMNIA,
}

export const SupportedChains: [Chain, ...Chain[]] = IS_INJECTIVE_TEST_SERVER
  ? [ActiveChain.INJECTIVE]
  : [ActiveChain.KAIA, ActiveChain.BERA, ActiveChain.SOMNIA]

export const ChainImages: Record<ChainId, string> = {
  [ChainId.KAIA]: getIconPath('kaia.png', 'chain'),
  [ChainId.KAIA_TESTNET]: getIconPath('kaia.png', 'chain'),
  [ChainId.BERA]: getIconPath('bera.png', 'chain'),
  [ChainId.BERA_TESTNET]: getIconPath('bera.png', 'chain'),
  [ChainId.INJECTIVE_TESTNET]: getIconPath('injective.png', 'chain'),
  [ChainId.SOMNIA]: getIconPath('somnia.png', 'chain'),
  [ChainId.SOMNIA_TESTNET]: getIconPath('somnia.png', 'chain'),
} as const

export const ChainNames: Record<ChainId, string> = {
  [ChainId.KAIA]: 'Kaia',
  [ChainId.KAIA_TESTNET]: 'Kairos',
  [ChainId.BERA]: 'Berachain',
  [ChainId.BERA_TESTNET]: 'Bepolia',
  [ChainId.INJECTIVE_TESTNET]: 'Injective Testnet',
  [ChainId.SOMNIA]: 'Somnia',
  [ChainId.SOMNIA_TESTNET]: 'Somnia Testnet',
}

export const ChainGasBuffer: Record<ChainId, bigint> = {
  [ChainId.KAIA]: parseEther('0.1'),
  [ChainId.KAIA_TESTNET]: parseEther('0.1'),
  [ChainId.BERA]: parseEther('0.001'),
  [ChainId.BERA_TESTNET]: parseEther('0.001'),
  [ChainId.INJECTIVE_TESTNET]: parseEther('0.01'),
  [ChainId.SOMNIA]: parseEther('0.01'),
  [ChainId.SOMNIA_TESTNET]: parseEther('0.01'),
}
